import styled from 'styled-components';

export const CountryWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  .main-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & .language {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
  }
`;
